let sections = document.querySelectorAll('.video-slider-eleven');

sections.forEach(section => {
    console.log(section);


    // handle clicking of play button
    let playButtons = section.querySelectorAll('.play-button');
    playButtons.forEach(button => {
        button.addEventListener('click', function() {
            
            // pause all other videos
            let videos = section.querySelectorAll('video');
            videos.forEach(video => {
                video.pause();
            });

            // remove 'playing' class from all other cards
            let cards = section.querySelectorAll('.playing');
            if (cards) {
                cards.forEach(card => {
                    card.classList.remove('playing');
                })
            }

            // play this video
            let video = this.parentNode.querySelector('video');
            if (video) {
                video.play();
            }

            // add playing to this card
            let card = this.parentNode;
            card.classList.add('playing');
        });
    });


    // handle pausing video
    let videos = section.querySelectorAll('video');
    videos.forEach(video => {
        video.addEventListener('pause', function() {

            // remove playing class from outer card
            let container = this.parentNode.parentNode;
            container.classList.remove('playing');
        })
    })
})